module.exports = __webpack_public_path__ + "img/bepreisung_5.50c951cd.png";